import { SingletonFlowchart } from "./singletonFlowchart";
import { SingletonEnginnering } from "./singletonEngineering";
import { Types } from "../../utils/nodeTypes"
import { UpdateNode } from "./simulationManagement/updateNode";
import EquipmentJoker from "./singletonTools/equipmentJoker";
import RebuilderNodes from "./singletonTools/RebuilderNodes";
import GetTimer from "../../utils/GetTimer";
// eslint-disable-next-line no-unused-vars
import DebugProperty from "@/components/flowchart/utils/debug"
import BuildSVG from "../../utils/buildSVG";
import { cleanUndoRedo } from "./undoRedo";
import { Selection } from "../selection/modelSelection";
import { NumberFormat } from "../../utils/tools";

export var SingletonAreas = {
    instance: function() {
        if (!SingletonAreas.instance) {
            SingletonAreas.instance = this;
        }
        return SingletonAreas.instance;
    },

    currentArea: "",
    areaOpenByNode: "",
    canLoadFormLoss: false,
    areas: new Array(),

    LoadAreas: async function (areasListData) {
      for(let i in areasListData){
        let a = areasListData[i]
        let result = this.areas.find(ar => a.area != null && ar.area == a.area)
        let configuration = JSON.parse(a.configuration)
  
        UpdateNode.UpdateArea(configuration)
  
        if(!result)
          this.areas.push({ ...a, configuration: configuration })
        else{
          this.areas.forEach(ar => {
            if(ar.area == a.area)
              ar.configuration = configuration
          })
        }
      }
    },
    
    LoadedAreas: function() {
      return this.areas.length > 0;
    },

    GetArea: function (area) {
      let ar = this.areas.find(a => a.area == area)
      if(ar) 
        return { configuration:  ar.configuration, transform: ar.transform }
      else
        return { configuration:  [], transform: null }
    },

    getPropertyByFlowchart: async function(flow) {
      let properties = [];
      try {
        for (let n in flow.configuration)
        {
          let node = flow.configuration[n]
          let ctr = SingletonFlowchart.getController(node)
          if(!ctr) continue
          let datas = await ctr.getProperties(node);
          properties = [...datas, ...properties]
        }
      } catch (e) {
        console.error("Falha os carregar o nós: ", flow);
        console.error("Erro: ", e);
      }
      
      return properties
    },

    getPropertiesOfAllAreas: async function() {
        let properties = [... SingletonFlowchart.Memory.getProperties()]
        let outherAreas = await this.getAllProperties()

        return [...properties, ...outherAreas]
    },

    getAllPropertiesToSimulation: async function() {
      let memoryProps = [...await SingletonFlowchart.Memory.getPropertiesToSimulation()]
      let outherAreas = await this.GetPropertiesToSimulation()

      return [...memoryProps, ...outherAreas]
    },

    getAllProperties: async function () {
      let properties = [];
  
      for(let iNodesArea in this.areas) {
        let flow = this.areas[iNodesArea]
        try {
            properties = [...await this.getPropertyByFlowchart(flow), ...properties]
        } catch (e) {
            console.log("Falha os carregar o nós: ", flow);
            console.log("Erro: ", e);
        }
      }
      return properties
    },

    UpdateAreas: async function() {
      if(!this.areas.length) return
        let timer = new GetTimer()
        timer.setTime1();
        let numberOfNodes = 0;
        for(let iNodesArea in this.areas) {
          let flowchart = this.areas[iNodesArea]
          if (flowchart.area == this.currentArea) continue

          let nodesList = []
          try {
            timer.setTime2()
            nodesList = UpdateNode.UpdateArea(flowchart.configuration)
            await this.returnNodesToConfiguration(flowchart, nodesList) // 1 seg
            numberOfNodes += flowchart.configuration.length
            console.log(`${NumberFormat(timer.getTimer2())} seg. [${flowchart.area} - ${flowchart.configuration.length} nós]`)
          } catch (e) {
            console.error("Falha os carregar o nós: ", flowchart);
            console.error("Erro: ", e);
          }
        }
        this.SaveAreasInLocalStorage(this.areas)
        return numberOfNodes;
    },

    async returnNodesToConfiguration(nodes, nodesList) {
      let area = this.areas.find(a => a.area == nodes.area) 
      if(area){
        area.configuration = await nodesList.map(n => n.clone())
      }
    },

    GetPropertiesToSimulation: async function (){
      let properties = [];
      let types = new Types();
  
      for(let iNodesArea in this.areas) {
        let flow = this.areas[iNodesArea]
        try {
            if(this.currentArea != flow.area){
              for (let n in flow.configuration)
              {
                  if(types.inputNodes.includes(flow.configuration[n].type))
                  {
                      let ctr = SingletonFlowchart.getController(flow.configuration[n]);
                      if(!ctr) continue
                      let datas = await ctr.getProperties(flow.configuration[n]);
                      properties = [...datas, ...properties]             
                  }
              }
            }
        } catch (e) {
          console.log("Falha os carregar o nós: ", flow);
          console.log("Erro: ", e);
        }
      }

      return properties
    },

    Reload: async function(){
      let xml = localStorage.xml ? await JSON.parse(localStorage.xml) : "";
      if (xml && xml.scenarioObjectStructure){
        this.LoadScenario(xml.scenarioObjectStructure)
      }
    },
    
    LoadScenario: async function(scenarioObjectStructure, canRebuild){
      console.log(`[ ATUALIZANDO DIAGRAMA ]`)
      let timer = new GetTimer()
      timer.setTime1()
      timer.setTime2()
      SingletonEnginnering.load(scenarioObjectStructure)
      
      if(canRebuild)
        RebuilderNodes.rebuild(this.areas, this.currentArea);

      let properties = await this.getAllProperties() 
      console.log(`${NumberFormat(timer.getTimer2())} seg. [Carregando - ${properties.length} atributos]`)

      timer.setTime2()
      await SingletonEnginnering.updatePropertyValues(properties);
      console.log(`${NumberFormat(timer.getTimer2())} seg. [Regras de operacionais - ${properties.length} atributos]`)
      timer.setTime2()
      await SingletonFlowchart.Memory.reloadNodes();
      let numberOfNodesInMemory = SingletonFlowchart.Memory.memory.length;
      console.log(`${NumberFormat(timer.getTimer2())} seg. [${this.currentArea} - ${numberOfNodesInMemory} nós]`)

      let numberOfNodes = await this.UpdateAreas()
      SingletonFlowchart.wasModified = false

      console.log(`${NumberFormat(timer.getTimer1())} seg. [TOTAL - ${numberOfNodes + numberOfNodesInMemory} nós]`)
      console.log(`[ ATUALIZADO COM SUCESSO! ]`)
    },

    UpdateArea: function(flow){
      let areasFlow = JSON.parse(sessionStorage.areasFlowchart).map(a => ({...a, configuration: JSON.parse(a.configuration)}))
      let area = areasFlow.find(a => a.area == flow.area)

      if(area){
        area.configuration = JSON.parse(flow.configuration);
        area.transform = flow.transform;
      }
      else
        areasFlow.push({id: flow.id, area: flow.area, configuration: JSON.parse(flow.configuration), transform: flow.transform })

      this.areas = areasFlow
      this.SaveAreasInLocalStorage(areasFlow)
    },

    SaveAreasInLocalStorage: function(areasList) {
      sessionStorage.areasFlowchart = JSON.stringify(areasList.map(a => ({...a , configuration: JSON.stringify(a.configuration)})))
    },

    GetJokersEquipments: function(key) {
      let jokerList = EquipmentJoker.FindJoker(key)
      let newJokers = EquipmentJoker.SetAreaWithEquipment(this.areas, jokerList)
      jokerList = [...jokerList, ...newJokers.filter(n => jokerList.find(j => j.op != n.op))]
      return jokerList.filter(j => j.area);
    },

    SaveJoker: function(node){
      let memoryNodes = EquipmentJoker.UpdateNodes(this.areas, node.jokers, this.currentArea)
      this.SaveNodeInMemory(memoryNodes)
      this.SaveAreasInLocalStorage(this.areas)
    },

    SaveNodeInMemory(nodes = new Array){
      nodes.forEach(n => {
        SingletonFlowchart.SaveNode(n)
      })
    },

    SaveStatus: function () {
      let flow = this.areas.find(a => a.area == this.currentArea)

      if(flow)
      {
        let nodes = SingletonFlowchart.Memory.getNodesToSave();

        for (const node of nodes) {
          if(!new Types().inputNodes.includes(node.type)) continue
          for (const prop of node.data) {
            SingletonEnginnering.setValue(prop)
          }
        }

        flow.configuration = nodes;
      } 
      else
      { 
        let width = document.querySelector("#canvas").clientWidth
        let transform = document.querySelector('#board').getAttribute('transform')
        flow = {
          id: 0,
          area: this.currentArea,
          configuration: SingletonFlowchart.Memory.getNodesToSave(),
          transform: transform + ` width(${width})`
        }
        this.areas.push(flow)
      }
      
      this.SaveAreasInLocalStorage(this.areas)
    },

    loadAreaByFlow: async function(flow){
      await flow.configuration.forEach((node) => {
        try {
          node.readOnly = readOnly;
          let ctr = SingletonFlowchart.getController(node)
          if(!ctr) return
          ctr.loadNode(node, SingletonFlowchart.openDialog, SingletonFlowchart.loadFlowchartTo);
        } catch (e) {
          console.log("Falha ao carregar o nó: ", node);
          console.log("Erro: ", e);
        }
      });
      
      if(flow.transform){
        this.transform = flow.transform
        BuildSVG.Resize(flow.transform)
      }
      
      SingletonFlowchart.Memory.clear();
      document.querySelector("#canvas").innerHTML = "";
      let unSelected = () => {
        SingletonFlowchart.unSelectNode();
        new Selection().cancelSelection();
      }
      let readOnly = this.readOnly
      let svg = BuildSVG.CreateSvg({
        readOnly,
        unSelected,
      });
      SingletonFlowchart.svg = svg;
      cleanUndoRedo();
    },

    KillAllSingletons: () => {
      SingletonFlowchart.Kill()
      SingletonEnginnering.Kill();
      SingletonAreas.Kill()
    },

    Kill: function () {
      this.currentArea = ""
      this.areaOpenByNode = ""
      this.areas = new Array()
      this.instance = null
    }
}
